import { ValidationFormat } from '@wix/ambassador-forms-v4-form-http/types';
import { EMPTY_VALUE } from '../../constants';
import { isNumber, isObject, isString } from '../../field-viewer/type-guards';
export function acceptOnlyValidProducts({ field, fieldValue }) {
    const isEmptyValue = fieldValue === EMPTY_VALUE;
    if (isEmptyValue) {
        return fieldValue;
    }
    if (!Array.isArray(fieldValue)) {
        return EMPTY_VALUE;
    }
    const validation = field.validation;
    if (validation?.predefined?.format !== ValidationFormat.PAYMENT) {
        return EMPTY_VALUE;
    }
    const validationProducts = validation.predefined.paymentOptions?.products || [];
    if (validationProducts.length === 0) {
        return EMPTY_VALUE;
    }
    const validProducts = fieldValue.filter((productValue)=>{
        const hasAllProps = isObject(productValue) && productValue.hasOwnProperty('productId') && productValue.hasOwnProperty('price') && productValue.hasOwnProperty('quantity');
        if (!hasAllProps) {
            return false;
        }
        const { price, quantity, productId } = productValue;
        const isValidPrice = isString(price) ? Number(price).toString() === price : isNumber(price);
        if (!isValidPrice) {
            return false;
        }
        const isValidQuantity = isNumber(quantity);
        if (!isValidQuantity) {
            return false;
        }
        const isExisted = validationProducts.some((product)=>product.id === productId);
        return isExisted;
    });
    return validProducts.length ? validProducts : EMPTY_VALUE;
}

//# sourceMappingURL=product-list-normalize-value.js.map